import React, {useState, useEffect, useRef, useMemo} from "react";
import {Links} from '../routes/PathLink'
import { Link } from "react-router-dom";

const Breadcrumb = ({breadcrumb}) => {

    return(
        <div className="flex items-center gap-2">
            {
            breadcrumb?.map((val, key) => (
                val.link ?
                <><Link className="text-accent" to={`${val.link}`}><div>{val.name}</div></Link>
                <div>/</div></>
                :
                <div>{val.name}</div>
            ))
            }
        </div>
    )

}

export default Breadcrumb;